import { render, staticRenderFns } from "./Fotos.vue?vue&type=template&id=233c0b41&scoped=true"
import script from "./Fotos.vue?vue&type=script&lang=js"
export * from "./Fotos.vue?vue&type=script&lang=js"
import style0 from "./Fotos.vue?vue&type=style&index=0&id=233c0b41&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c0b41",
  null
  
)

export default component.exports